/**
 * <cart-popover> — wraps the cart icon.
 *
 * The cart icon no longer navigates to /cart; it opens the cart drawer
 * (<cart-notification>) instead. The href is left in the markup so the icon
 * still works as a plain link when JavaScript is unavailable.
 *
 * Hover-to-open was removed when the popover became a drawer: sliding a
 * full-height panel in on mouseover is jarring, so opening is click-only.
 */
class CartPopover extends HTMLElement {
  constructor() {
    super();

    this.link = this.querySelector('#cart-icon-bubble');
    if (!this.link) return;

    this.link.addEventListener('click', this.onClick.bind(this));
  }

  get drawer() {
    // The drawer lives outside this element (it is fixed to the viewport),
    // so look it up globally rather than inside the icon wrapper.
    return document.querySelector('cart-notification');
  }

  onClick(event) {
    const drawer = this.drawer;
    if (!drawer || typeof drawer.open !== 'function') return; // fall back to /cart

    // Let modified clicks (new tab, etc.) behave like a normal link.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    event.preventDefault();
    if (drawer.isOpen()) {
      drawer.close();
    } else {
      // Return focus to the cart icon when the drawer closes. It lives in the
      // pinned header, so restoring focus there can never scroll the page.
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.link);
      drawer.open('sticky');
    }
  }
}

customElements.define('cart-popover', CartPopover);
